import React from 'react';
import {
	Label,
	Paragraph,
	UploadFiles,
	tokens,
} from '@welbe/web-design-system';
import { AlertContainer, UploadContainer } from './UploadFile.styles';
import { useUploadFile } from './UploadFile.hooks';
import { FiAlertCircle } from 'react-icons/fi';
import { Result } from '../Result/Result';

export const UploadFile = () => {
	const { isLoading, error, fileName, handleFile, handleClearFile } =
		useUploadFile();

	return (
		<div>
			<Paragraph
				fontSize="18px"
				fontWeight="400"
				color={tokens.color_primary}
				padding="0px 0px 15px 0px"
			>
				Exposición
			</Paragraph>
			<AlertContainer>
				<FiAlertCircle color={tokens.color_primary} size={35} />
				<Paragraph>
					De acuerdo con la Normativa es necesario contar con un estudio
					ambiental para el reconocimiento y evaluación de los niveles de
					exposición al riesgo dentro de la empresa. Si cuentas con este estudio
					podrás subirlo en esta sección.
				</Paragraph>
			</AlertContainer>
			<Paragraph fontSize="14px" fontWeight="400" color={tokens.color_primary}>
				¿Cuentas con algún documento de estudio ambiental? (Por normatividad se
				debe realizar un estudio para medir el nivel de exposición de los
				colaboradores)
			</Paragraph>
			<UploadContainer>
				<Label margin="0">Subir archivo</Label>
				<UploadFiles
					error={error}
					loading={isLoading}
					deleteFile
					onHandleFile={handleFile}
					onClearFile={handleClearFile}
					fileName={fileName || ''}
				/>
			</UploadContainer>
			<Result />
		</div>
	);
};
